import React from 'react'
import { Link } from 'react-router-dom'
import SEO from '../Components/SEO'
import ServicesSidebar from '../Components/ServicesSidebar'
import { ContactInfo } from '../Utils/Data'

const AboutUs = ({ title = "About KD General Transport" }) => {
  return (
    <div>
      <SEO
        title="About KD General Transport LLC | Top Transportation Company in Dubai, UAE"
        description="KD General Transport LLC - Leading transportation company in Dubai, UAE. Best Freezer Transportation, Chiller Transportation, Mover Transportation & Trailer Transportation services in Dubai. Serving Downtown Dubai, JBR, Business Bay & All Areas. Licensed, Insured, 24/7 Service. Call +971555592206"
        keywords="about KD General Transport, transportation company Dubai, best transport company Dubai, top transport company Dubai, logistics company Dubai, freezer transportation company Dubai, chiller transportation company Dubai, mover transportation company Dubai, trailer transportation company Dubai, transport services Dubai, professional transport Dubai, reliable transport Dubai, licensed transport Dubai, insured transport Dubai, transportation company UAE, logistics company UAE, professional transport UAE, reliable transport UAE, licensed transport UAE, insured transport UAE"
      />
      <div className="page-title-style01 page-title-negative-top pt-bkg02">
  <div className="container">
    <div className="row">
      <div className="col-md-12">
        <h1>{title}</h1>
         
        {/* .breadcrumb-container end */}
      </div>
      {/* .col-md-12 end */}
    </div>
    {/* .row end */}
  </div>
  {/* .container end */}
</div>






<div className="page-content">
  <div className="container">
    <div className="row">
      <aside className="col-md-3 aside aside-left">
        <ServicesSidebar />
        <ul className="aside-widgets">
          {/* .widget.widget-text start */}
          <li className="widget widget-text">
            <div className="title">
              <h3>contact us</h3>
            </div>
            <img src={`${process.env.PUBLIC_URL}/img/pics/locations.jpg`} alt="contact us" />
            <br />
            <p>Let us know what can we do for you. Contact us today!</p>
            <Link to="/contact" className="read-more">
              <span>
                Contact us
                <i className="fa fa-chevron-right" />
              </span>
            </Link>
          </li>
          {/* .widget-text end */}
        </ul>
        {/* .aside-widgets end */}
      </aside>
      {/* .aside.aside-left end */}
      <div className="col-md-9">
               <div className="custom-heading" style={{ marginBottom: '30px' }}>
                 <h2 style={{ fontSize: '36px', fontWeight: '700', color: '#2c3e50', marginBottom: '15px' }}>Company Profile</h2>
               </div>
               <div style={{ marginBottom: '40px' }}>
                 <img
                   className="float-right"
                   src={`${process.env.PUBLIC_URL}/img/pics/img25.png`}
                   alt="KD General Transport Fleet"
                   width={360}
                   style={{
                     borderRadius: '8px',
                     boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
                     marginLeft: '30px',
                     marginBottom: '20px'
                   }}
                 />
                 <p style={{ fontSize: '16px', lineHeight: '1.8', color: '#555', marginBottom: '20px' }}>
                   KD General Transport LLC is a leading transportation and logistics 
                   company operating across the United Arab Emirates. With a comprehensive 
                   fleet of specialized vehicles, we provide professional transportation 
                   services including freezer vans, chiller trucks, moving services, and 
                   trailer solutions. Our commitment to excellence, reliability, and 
                   customer satisfaction has made us a trusted partner for businesses 
                   and individuals throughout UAE.
                 </p>
                 <p style={{ fontSize: '16px', lineHeight: '1.8', color: '#555' }}>
                   We understand the unique challenges of transportation in the UAE's 
                   diverse climate and business environment. Whether you need temperature-controlled 
                   transportation for perishable goods, reliable moving services for your 
                   relocation, or heavy-duty trailer solutions for large-scale projects, 
                   KD General Transport delivers with precision and professionalism.
                 </p>
               </div>
        <br />
        <div className="row" style={{ marginBottom: '50px' }}>
          <div className="col-md-12">
            <div className="custom-heading" style={{ textAlign: 'center', marginBottom: '30px' }}>
              <h2 style={{ fontSize: '36px', fontWeight: '700', color: '#333', marginBottom: '20px' }}>Our Vision</h2>
            </div>
            <div style={{ 
              background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)', 
              padding: '40px', 
              borderRadius: '10px',
              boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
              textAlign: 'center'
            }}>
              <p style={{ 
                fontSize: '24px', 
                lineHeight: '1.8', 
                color: '#2c3e50', 
                fontWeight: '400',
                margin: '0',
                fontStyle: 'italic'
              }}>
                To become the most trusted and preferred transportation and logistics partner across the United Arab Emirates, 
                recognized for our unwavering commitment to excellence, innovation, and customer-centric solutions. 
                We envision a future where KD General Transport sets the industry standard for reliability, professionalism, 
                and sustainable growth, empowering businesses and individuals to achieve their goals through seamless, 
                efficient, and world-class transportation services.
              </p>
            </div>
          </div>
        </div>
        {/* .row end */}
        <div className="row">
                 <div className="col-md-5" style={{ 
                   background: '#f8f9fa', 
                   padding: '30px', 
                   borderRadius: '8px',
                   marginBottom: '20px'
                 }}>
                   <div className="custom-heading" style={{ marginBottom: '20px' }}>
                     <h3 style={{ fontSize: '24px', fontWeight: '700', color: '#2c3e50' }}>Our Mission</h3>
                   </div>
                   {/* .custom-heading end */}
                   <p style={{ fontSize: '15px', lineHeight: '1.8', color: '#555', margin: '0' }}>
                     Our mission is to provide exceptional transportation and logistics 
                     services across the UAE, ensuring the safe, timely, and efficient 
                     delivery of goods and services. We are committed to maintaining 
                     the highest standards of professionalism, reliability, and customer 
                     satisfaction while contributing to the growth and development of 
                     businesses throughout the Emirates.
                   </p>
                 </div>
                 {/* .col-md-5 end */}
                 <div className="col-md-7" style={{ 
                   background: '#f8f9fa', 
                   padding: '30px', 
                   borderRadius: '8px',
                   marginBottom: '20px'
                 }}>
                   <div className="custom-heading" style={{ marginBottom: '20px' }}>
                     <h3 style={{ fontSize: '24px', fontWeight: '700', color: '#2c3e50' }}>Our Commitment</h3>
                   </div>
                   {/* .custom-heading end */}
                   <ul className="fa-ul" style={{ margin: '0', paddingLeft: '0' }}>
                     <li style={{ marginBottom: '12px', fontSize: '15px', lineHeight: '1.6', color: '#555' }}>
                       <i className="fa fa-li fa-check-circle" style={{ color: '#25D366' }} />
                       Providing high-quality transportation services across all seven Emirates
                     </li>
                     <li style={{ marginBottom: '12px', fontSize: '15px', lineHeight: '1.6', color: '#555' }}>
                       <i className="fa fa-li fa-check-circle" style={{ color: '#25D366' }} />
                       Maintaining a modern, well-maintained fleet of specialized vehicles
                     </li>
                     <li style={{ marginBottom: '12px', fontSize: '15px', lineHeight: '1.6', color: '#555' }}>
                       <i className="fa fa-li fa-check-circle" style={{ color: '#25D366' }} />
                       Ensuring temperature-controlled transportation for perishable goods
                     </li>
                     <li style={{ marginBottom: '12px', fontSize: '15px', lineHeight: '1.6', color: '#555' }}>
                       <i className="fa fa-li fa-check-circle" style={{ color: '#25D366' }} />
                       Safety as our top priority with certified drivers and vehicles
                     </li>
                     <li style={{ marginBottom: '12px', fontSize: '15px', lineHeight: '1.6', color: '#555' }}>
                       <i className="fa fa-li fa-check-circle" style={{ color: '#25D366' }} />
                       Offering competitive pricing with transparent, no-hidden-cost service
                     </li>
                     
                   </ul>
                   {/* .fa-ul end */}
                 </div>
          {/* .col-md-7 end */}
        </div>
        {/* .row end */}
        <div className="custom-heading" style={{ marginTop: '50px', marginBottom: '30px' }}>
          <h2 style={{ fontSize: '32px', fontWeight: '700', color: '#333' }}>Chief Executive Officer</h2>
        </div>
        {/* .custom-heading end */}
        <ul className="team-list clearfix">
          <li style={{ 
            background: '#ffffff',
            padding: '30px',
            borderRadius: '10px',
            boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
            marginBottom: '30px'
          }}>
            <img 
              src={`${process.env.PUBLIC_URL}/img/ceo.jpg`} 
              alt="CEO - KD General Transport" 
              style={{
                borderRadius: '8px',
                marginBottom: '25px',
                boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
              }}
            />
            <div className="team-details-container">
              <div className="team-details" style={{ marginBottom: '20px' }}>
                <h5 style={{ fontSize: '24px', fontWeight: '700', color: '#2c3e50', marginBottom: '8px' }}>Abdul Hameed</h5>
                <p className="position" style={{ fontSize: '16px', color: '#7f8c8d', fontWeight: '500', margin: '0' }}>CEO & Founder</p>
              </div>
              {/* .team-details end */}
              <p style={{ fontSize: '16px', lineHeight: '1.8', color: '#555', marginBottom: '30px' }}>
                Leading KD General Transport with a clear vision to provide exceptional transportation and logistics services across the UAE, I am Abdul Hameed, the CEO and driving force behind the company. With extensive hands-on experience in logistics and transportation, I founded KD General Transport with a strong commitment to reliability, professionalism, and customer satisfaction.
              </p>
              <p style={{ fontSize: '16px', lineHeight: '1.8', color: '#555', marginBottom: '30px' }}>
                Under my leadership, KD General Transport has steadily grown to serve both businesses and individuals across all seven Emirates. We specialize in a wide range of transportation solutions, including freezer vans, chiller trucks, moving services, and trailer solutions, ensuring safe, efficient, and timely delivery tailored to our clients' needs. Our focus remains on building long-term partnerships through quality service, trust, and operational excellence.
              </p>
              <div style={{ 
                marginTop: '40px', 
                textAlign: 'center',
                paddingTop: '30px',
                borderTop: '2px solid #e0e0e0'
              }}>
                <style>{`
                  @keyframes pulse {
                    0% {
                      box-shadow: 0 0 0 0 rgba(0, 109, 183, 0.7);
                    }
                    70% {
                      box-shadow: 0 0 0 10px rgba(0, 109, 183, 0);
                    }
                    100% {
                      box-shadow: 0 0 0 0 rgba(0, 109, 183, 0);
                    }
                  }
                  @keyframes shimmer {
                    0% {
                      background-position: -1000px 0;
                    }
                    100% {
                      background-position: 1000px 0;
                    }
                  }
                  @keyframes iconBounce {
                    0%, 100% {
                      transform: translateX(0);
                    }
                    50% {
                      transform: translateX(5px);
                    }
                  }
                  .ceo-contact-btn {
                    display: inline-block;
                    padding: 16px 40px;
                    background: linear-gradient(135deg, #006db7 0%, #0275c4 100%);
                    color: #ffffff;
                    text-decoration: none;
                    borderRadius: 50px;
                    fontSize: 16px;
                    fontWeight: 700;
                    textTransform: uppercase;
                    letterSpacing: 0.5px;
                    position: relative;
                    overflow: hidden;
                    cursor: pointer;
                    transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
                    boxShadow: 0 6px 20px rgba(0, 109, 183, 0.4);
                    animation: pulse 2s infinite;
                    border: 2px solid transparent;
                  }
                  .ceo-contact-btn::before {
                    content: '';
                    position: absolute;
                    top: 0;
                    left: -100%;
                    width: 100%;
                    height: 100%;
                    background: linear-gradient(
                      90deg,
                      transparent,
                      rgba(255, 255, 255, 0.3),
                      transparent
                    );
                    transition: left 0.5s;
                  }
                  .ceo-contact-btn:hover::before {
                    left: 100%;
                  }
                  .ceo-contact-btn:hover {
                    transform: translateY(-3px) scale(1.05);
                    boxShadow: 0 10px 30px rgba(0, 109, 183, 0.6);
                    background: linear-gradient(135deg, #0275c4 0%, #006db7 100%);
                  }
                  .ceo-contact-btn:active {
                    transform: translateY(-1px) scale(1.02);
                  }
                  .ceo-contact-btn i {
                    marginRight: 12px;
                    fontSize: 20px;
                    display: inline-block;
                    transition: transform 0.3s ease;
                  }
                  .ceo-contact-btn:hover i {
                    animation: iconBounce 0.6s ease infinite;
                  }
                `}</style>
                <a 
                  href={`https://wa.me/${ContactInfo.contact_phone[0]?.replace(/[^0-9]/g, '')}?text=Hi%20Abdul%20Hameed!%20I%20would%20like%20to%20contact%20you%20regarding%20KD%20General%20Transport%20services.`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="ceo-contact-btn"
                >
                  <i className="fa fa-whatsapp"></i>
                  Contact CEO
                </a>
              </div>
            </div>
            {/* .team-details-container end */}
          </li>
          {/* team-member end */}
          
          {/* team-member end */}
        </ul>
        {/* .team list end */}
      </div>
      {/* .col-md-9 end */}
    </div>
    {/* .row end */}
  </div>
  {/* .container end */}
</div>

    </div>
  )
}

export default AboutUs
